import React from "react";
import { useTranslation } from "react-i18next";
// import logo from "../../images/emirates_made_logo.svg";

import logo from "../../assets/images/logo.png";

const FooterSection = () => {
  const { t } = useTranslation();

  return (
    <footer style={{ backgroundColor: "#f7f7f7", marginTop: "80px" }}>
      {/* Top section */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          padding: "60px 10%",
          gap: "40px",
          alignItems: "start",
        }}
      >
        {/* Left - Logo and description */}
        <div>
          <img
            src={logo}
            alt={t("FooterSection.LogoAlt") || "Emirates Made logo"}
            style={{ height: "50px", marginBottom: "20px" }}
          />
          <p
            style={{
              color: "#222",
              fontSize: "14px",
              lineHeight: "1.7",
              maxWidth: "400px",
            }}
          >
            {t("FooterSection.Description") ||
              "Emirates Made is a national initiative by the Ministry of Industry and Advanced Technology to promote UAE-made products and strengthen the local manufacturing ecosystem."}
          </p>
        </div>

        {/* Middle - Quicklinks */}
        <div>
          <h4
            style={{
              fontSize: "14px",
              fontWeight: "700",
              textTransform: "uppercase",
              marginBottom: "15px",
              color: "#000",
            }}
          >
            {t("FooterSection.Quicklinks") || "Quick Links"}
          </h4>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
            <li>
              <a
                href="#about"
                style={linkStyle}
              >
                {t("FooterSection.AboutInitiative") || "About Emirates Made"}
              </a>
            </li>
            <li>
              <a
                href="#partners"
                style={linkStyle}
              >
                {t("FooterSection.OurPartners") || "Our Partners"}
              </a>
            </li>
            <li>
              <a
                href="#benefits"
                style={linkStyle}
              >
                {t("FooterSection.MemberBenefits") || "Member Benefits"}
              </a>
            </li>
            <li>
              <a
                href="#label"
                style={linkStyle}
              >
                {t("FooterSection.HowToGetLabel") || "How to Obtain the Label"}
              </a>
            </li>
          </ul>
        </div>

        {/* Right - Contact info */}
        <div>
          <h4
            style={{
              fontSize: "14px",
              fontWeight: "700",
              textTransform: "uppercase",
              marginBottom: "15px",
              color: "#000",
            }}
          >
            {t("FooterSection.ContactUs") || "Contact Us"}
          </h4>

          <p style={{ fontSize: "14px", color: "#222", marginBottom: "8px" }}>
            📞 +971 2 667 1717
          </p>
          <p style={{ fontSize: "14px", color: "#222", marginBottom: "20px" }}>
            ✉️ info@emiratesmade.ae
          </p>

          <a
            href="#contact"
            style={{
              color: "#007a56",
              fontWeight: "600",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {t("FooterSection.GetInTouch") || "Get in Touch"}{" "}
            <span style={{ fontSize: "18px" }}>›</span>
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        style={{
          backgroundColor: "var(--uae-deep-green)",
          color: "#fff",
          padding: "15px 10%",
          fontSize: "13px",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <span>
          {t("FooterSection.Copyright", { defaultValue: "(c) 2025 Emirates Made - An initiative inspired by the National Industrial Strategy - Ministry of Industry and Advanced Technology, UAE" })}
        </span>
        <div style={{ display: "flex", gap: "15px" }}>
          <a href="#terms" style={bottomLinkStyle}>
            {t("FooterSection.TermsAndConditions") || "Terms & Conditions"}
          </a>
          <span>•</span>
          <a href="#privacy" style={bottomLinkStyle}>
            {t("FooterSection.PrivacyPolicy") || "Privacy Policy"}
          </a>
          <span>•</span>
          <a href="#cookies" style={bottomLinkStyle}>
            {t("FooterSection.Cookies") || "Cookies"}
          </a>
        </div>
      </div>
    </footer>
  );
};

const linkStyle = {
  color: "#0a2750",
  textDecoration: "none",
  fontWeight: "500",
};

const bottomLinkStyle = {
  color: "#fff",
  textDecoration: "none",
  fontWeight: "500",
};

export default FooterSection;


// import React from "react";
// import { useTranslation } from "react-i18next";
// import logo from "../../images/logo_english_8beed26c44.svg";

// const FooterSection = () => {
//   const { t } = useTranslation();

//   return (
//     <footer style={{ backgroundColor: "#f7f7f7", marginTop: "80px" }}>
//       {/* Top section */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "1fr 1fr 1fr",
//           padding: "60px 10%",
//           gap: "40px",
//           alignItems: "start",
//         }}
//       >
//         {/* Left - Logo and description */}
//         <div>
//           <img
//             src={logo}
//             alt={t("FooterSection.LogoAlt")}
//             style={{ height: "50px", marginBottom: "20px" }}
//           />
//           <p
//             style={{
//               color: "#222",
//               fontSize: "14px",
//               lineHeight: "1.7",
//               maxWidth: "400px",
//             }}
//           >
//             {t("FooterSection.Description")}
//           </p>
//         </div>

//         {/* Middle - Quicklinks */}
//         <div>
//           <h4
//             style={{
//               fontSize: "14px",
//               fontWeight: "700",
//               textTransform: "uppercase",
//               marginBottom: "15px",
//               color: "#000",
//             }}
//           >
//             {t("FooterSection.Quicklinks")}
//           </h4>
//           <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
//             <li>
//               <a
//                 href="#about"
//                 style={{
//                   color: "#0a2750",
//                   textDecoration: "none",
//                   fontWeight: "500",
//                 }}
//               >
//                 {t("FooterSection.AboutProgram")}
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#partners"
//                 style={{
//                   color: "#0a2750",
//                   textDecoration: "none",
//                   fontWeight: "500",
//                 }}
//               >
//                 {t("FooterSection.OurPartners")}
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#faqs"
//                 style={{
//                   color: "#0a2750",
//                   textDecoration: "none",
//                   fontWeight: "500",
//                 }}
//               >
//                 {t("FooterSection.FAQs")}
//               </a>
//             </li>
//             <li>
//               <a
//                 href="#code"
//                 style={{
//                   color: "#0a2750",
//                   textDecoration: "none",
//                   fontWeight: "500",
//                 }}
//               >
//                 {t("FooterSection.CodeOfPractice")}
//               </a>
//             </li>
//           </ul>
//         </div>

//         {/* Right - Contacts */}
//         <div>
//           <h4
//             style={{
//               fontSize: "14px",
//               fontWeight: "700",
//               textTransform: "uppercase",
//               marginBottom: "15px",
//               color: "#000",
//             }}
//           >
//             {t("FooterSection.Contacts")}
//           </h4>

//           <p style={{ fontSize: "14px", color: "#222", marginBottom: "8px" }}>
//             📞 199077
//           </p>
//           <p style={{ fontSize: "14px", color: "#222", marginBottom: "20px" }}>
//             ✉️ info@saudimade.sa
//           </p>

//           <a
//             href="#contact"
//             style={{
//               color: "#007a56",
//               fontWeight: "600",
//               textDecoration: "none",
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "5px",
//             }}
//           >
//             {t("FooterSection.ContactUs")}{" "}
//             <span style={{ fontSize: "18px" }}>›</span>
//           </a>
//         </div>
//       </div>

//       {/* Bottom bar */}
//       <div
//         style={{
//           backgroundColor: "#0a2750",
//           color: "#fff",
//           padding: "15px 10%",
//           fontSize: "13px",
//           display: "flex",
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//         }}
//       >
//         <span>{t("FooterSection.Copyright")}</span>
//         <div style={{ display: "flex", gap: "15px" }}>
//           <a
//             href="#terms"
//             style={{ color: "#fff", textDecoration: "none", fontWeight: "500" }}
//           >
//             {t("FooterSection.TermsAndConditions")}
//           </a>
//           <span>•</span>
//           <a
//             href="#privacy"
//             style={{ color: "#fff", textDecoration: "none", fontWeight: "500" }}
//           >
//             {t("FooterSection.PrivacyPolicy")}
//           </a>
//           <span>•</span>
//           <a
//             href="#cookies"
//             style={{ color: "#fff", textDecoration: "none", fontWeight: "500" }}
//           >
//             {t("FooterSection.Cookies")}
//           </a>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default FooterSection;



